import { createActions, createReducer } from "reduxsauce";
import storage from "redux-persist/lib/storage";
import { IQuoteDetailItem } from "models/QuoteDetailItem";

const persistConfig = {
  key: "root",
  storage,
};

export const { Types, Creators } = createActions({
  setDistributionCenter: ["distributionCenter"],
  setSaveInProgress: ["saveInProgress"],
  setCustomerCode: ["customerCode"],
});

interface IActionsInProgress {
  id:string,
  progress: boolean
}

const INITIAL_STATE: {
  distributionCenter: string,
  saveInProgress: Array<IActionsInProgress>,
  quoteDetailItems: Array<IQuoteDetailItem>,
  customerCode: string
} = {
  distributionCenter: '',
  saveInProgress: [],
  quoteDetailItems: [],
  customerCode: ''
};

const setQuoteDetailItems = (state = INITIAL_STATE, action: any )  => {
  return { ...state, ...action.value};
} 

const setQuoteDetailItem = (state = INITIAL_STATE, action: any )  => {
  let quoteItens = state.quoteDetailItems;
  
  quoteItens = [...quoteItens, action.value]; 

  return { ...state, quoteDetailItems: quoteItens};
} 

const setDistributionCenter = (state = INITIAL_STATE, action: any) => ({
  ...state,
  distributionCenter: action.value,
});


const setSaveInProgress = (state = INITIAL_STATE, action: any) => ({
  ...state,
  saveInProgress: action.value,
});

const setCustomerCode = (state= INITIAL_STATE, action: any) => ({
  ...state,
  customerCode: action.customerCode,
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_DISTRIBUTION_CENTER as any]: setDistributionCenter,
  [Types.SET_SAVE_IN_PROGRESS as any]: setSaveInProgress,
  [Types.SET_CUSTOMER_CODE as any]: setCustomerCode
});
